import type { StringBoolean } from "@/models/enum/stringBoolean";

export default class BooleanWithDetails {
  boolean: StringBoolean | string = "";
  details: string = "";
}
